<template>
    <div class="row">
        <div class="col-md-9">
            <Loading v-if="showLoading" />
            <div class="card mb-3">
                <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">اطلاعات سفارش</div>
                <div class="card-body">
                    <div class="timeline-steps aos-init aos-animate mb-2" v-if="false">
                        <div v-for="(step,index) in flows" :key="index" :class="order.sort == step.sort ? 'timeline-step mb-0 current' : (order.sort > step.sort ? 'timeline-step active' : 'timeline-step mb-0')">
                            <div class="timeline-content" data-toggle="popover" data-trigger="hover" data-placement="top">
                                <div class="inner-circle"></div>
                                <p class="h6 text-muted mt-2 mb-0 mb-lg-0">{{ step.sort > order.sort ? step.title : (step.subFlows[order.flowStepStatusId] || step.title) }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover mb-0 order-table-details" v-if="order.domainMetadata && Object.keys(order.domainMetadata).length">
                            <tbody>
                                <tr>
                                    <td>شماره سفارش:</td>
                                    <td>{{ order.orderId }}</td>
                                    <td>وضعیت سفارش:</td>
                                    <td>{{ order.statusTitle }}</td>
                                    <td>نوع سفارش:</td>
                                    <td>{{ order.orderType || '-' }}</td>
                                </tr>
                                <tr>
                                    <td>کاربر تایید کننده مالی:</td>
                                    <td>{{ order.financeVerify ? order.financeVerifier : '-' }}</td>
                                    <td>تاریخ سفارش:</td>
                                    <td>{{ order.createdAtPersian }}</td>
                                    <td>نام مشتری:</td>
                                    <td>{{ order.domainMetadata.firstName ? (order.domainMetadata.firstName + ' ' + order.domainMetadata.lastName) : order.domainMetadata.companyNameFa }}</td>
                                </tr>
                                <tr>
                                    <td>شماره همراه:</td>
                                    <td>{{ order.domainMetadata.mobile || '-' }}</td>
                                    <td>شناسه ملی:</td>
                                    <td>{{ order.domainMetadata.nationalId }}</td>
                                    <td>نام شرکت:</td>
                                    <td>{{ order.domainMetadata.companyNameFa }}</td>
                                </tr>
                                <tr v-if="order.description" style="border-left: 1px solid #262644">
                                    <td>توضیحات عدم تایید/مرجوعی:</td>
                                    <td colspan="5">{{ order.description }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="card mb-3">
                        <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">کارت های این سفارش</div>
                        <div class="card-body">
                            <button class="btn btn-success btn-rounded mb-4 ml-2" v-if="order.flowStepStatusId == 4 && !$store.state.userData.isOrganization && !$store.state.userData.isPishkhan" @click="approveOrRejectAll(true)">تایید سفارش</button>
                            <button class="btn btn-danger btn-rounded mb-4" data-toggle="modal" data-target="#reject-order" v-if="order.flowStepStatusId == 4 && !$store.state.userData.isOrganization && !$store.state.userData.isPishkhan">عدم تایید سفارش</button>
                            <div class="card bg-gray-100 mb-3" v-for="(orderItem,index) in order.orderItems" :key="index">
                                <div class="col-md-12">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <img :src="orderItem.theme ? 'https://cardapi.sabinarya.com' + orderItem.theme.address : orderItem.imageUrl" :alt="orderItem.theme ? orderItem.theme.title : ''" class="my-3 rounded-10">
                                        </div>
                                        <div class="col-md-9 pr-0 mt-3">
                                            <h5 class="theme-title mb-3"><b>{{ orderItem.theme ? orderItem.theme.title : 'بن کارت با طرح دلخواه' }}</b></h5>
                                            <h5 class="theme-title mb-3" v-if="orderItem.count">تعداد : <b>{{ orderItem.count }}</b></h5>
                                            <h5 class="theme-title mb-3">وضعیت : 
                                                <span v-if="orderItem.status == 1"><b>در انتظار بررسی</b></span>
                                                <span v-else-if="orderItem.status == 2"><b>تایید شده</b></span>
                                                <span v-else-if="orderItem.status == 3"><b>عدم تایید</b></span>
                                                <span v-else-if="orderItem.status == 4"><b>پرداخت نشده</b></span>
                                                <span v-else><b>شارژ شده</b></span>
                                            </h5>
                                            <div class="header-button-box">
                                                <button class="btn btn-primary btn-rounded" v-if="!orderItem.themeId" @click="downloadImage(orderItem.imageUrl)" target="_blank">مشاهده تصویر کارت</button>
                                                <button class="btn btn-warning mr-2 btn-rounded" v-if="!orderItem.themeId" @click="downloadImageDirectly(orderItem.orderItemId)" target="_blank">دانلود تصویر کارت</button>
                                            </div>
                                            <div class="footer-button-box" v-if="orderItem.cardId && order.orderTypeId != 2 && ($store.state.adminTokenExpireTime || new Date().getTime() > $store.state.adminTokenExpireTime) && !$store.state.userData.isOrganization">
                                                <button class="btn btn-success btn-rounded ml-2" data-toggle="modal" data-target="#cards-pans" v-if="orderItem.cardId && order.orderTypeId != 2 && (!$store.state.adminTokenExpireTime || new Date().getTime() > $store.state.adminTokenExpireTime)" @click="getCardsDetails(orderItem.key)">دریافت اطلاعات کارت ها</button>
                                                <button class="btn btn-success btn-rounded ml-2" v-if="orderItem.cardId && order.orderTypeId != 2 && new Date().getTime() <= $store.state.adminTokenExpireTime" @click="getCardsDetails(orderItem.key)">دریافت اطلاعات کارت ها</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal effect-scale" id="cards-pans" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-centered" role="document">
                                        <div class="modal-content modal-content-demo">
                                            <div class="modal-header">
                                                <h6 class="modal-title">اطلاعات کارت ها</h6>
                                                <button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                                            </div>
                                            <div class="modal-body">
                                                <div class="alert alert-info">
                                                    <p>کد اعتبارسنجی به شماره همراه شما ارسال شد</p>
                                                </div>
                                                <div class="form-group">
                                                    <label>کد اعتبارسنجی</label>
                                                    <input type="tel" class="form-control text-center" v-mask="'#####'" v-model="token">
                                                </div>
                                                <button class="btn btn-success" @click="setToken">ثبت و تایید</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card mb-3" v-if="((order.flowStepStatusId == 21 && !order.financeVerify) || order.flowStepStatusId == 31 || order.flowStepStatusId == 8) && !$store.state.userData.isOrganization && !$store.state.userData.isPishkhan">
                <Loading v-if="showLoading" />
                <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">عملیات</div>
                <div class="card-body">
                    <button class="btn btn-success btn-block" @click="financialApprove" v-if="order.flowStepStatusId == 21 && !order.financeVerify">تاییدیه مالی</button>
                    <button class="btn btn-primary btn-block" @click="sent" v-if="order.flowStepStatusId == 31">ارسال شده</button>
                    <button class="btn btn-info btn-block" @click="delivered" v-if="order.flowStepStatusId == 8">تحویل شده</button>
                    <button class="btn btn-warning btn-block" data-effect="effect-scale" data-toggle="modal" href="#refound" v-if="order.flowStepId == 43 && order.flowStepStatusId == 8">ثبت مرجوعی سفارش</button>
                </div>
            </div>
            <div class="card mb-3" v-if="order.flowStepStatusId == 1 && !order.financeVerify && $store.state.userData.isOrganization">
                <Loading v-if="showLoading" />
                <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">پرداخت هزینه سفارش</div>
                <div class="card-body">
                    <div class="alert alert-primary">
                        <p class="mb-0">میزان موجودی کیف پول : <b>{{ deposit }} ریال</b></p>
                    </div>
                    <button class="btn btn-success btn-block" :disabled="order.totalAmount > parseInt(deposit.toString().replace(/,/g,''))" @click="payWithWallet">پرداخت از کیف پول</button>
                    <button class="btn btn-warning btn-block" @click="chargeDeposit" v-if="order.totalAmount > parseInt(deposit.toString().replace(/,/g,''))">افزایش موجودی کیف پول ({{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(order.totalAmount - parseInt(deposit.toString().replace(/,/g,''))) }} ریال)</button>
                </div>
            </div>
            <div class="card mb-3">
                <Loading v-if="showLoading" />
                <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">اطلاعات مالی</div>
                <div class="card-body">
                    <div class="d-flex flex-row justify-content-between">
                        <div class="m-1">
                            <span>مبلغ سفارش:</span>
                        </div>
                        <div class="m-1">
                            <strong>{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(Math.abs(order.amount - (order.shippingCost || 0))) }} ریال</strong>
                        </div>
                    </div>
                    <hr>
                    <div class="d-flex flex-row justify-content-between" v-if="order.discount != 0">
                        <div class="m-1">
                            <span>مبلغ تخفیف:</span>
                        </div>
                        <div class="m-1">
                            <strong>{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(order.discount) }} ریال</strong>
                        </div>
                    </div>
                    <hr>
                    <div class="d-flex flex-row justify-content-between">
                        <div class="m-1">
                            <span>مبلغ کل:</span>
                        </div>
                        <div class="m-1">
                            <strong>{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(order.totalAmount) }} ریال</strong>
                        </div>
                    </div>
                    <hr>
                    <div class="d-flex flex-row justify-content-between">
                        <div class="m-1">
                            <span>وضعیت پرداخت:</span>
                        </div>
                        <div class="m-1">
                            <span v-if="order.financeVerify" class="badge badge-success">پرداخت شده</span>
                            <span v-else class="badge badge-danger">پرداخت نشده</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal effect-scale" id="reject-order" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content modal-content-demo">
                    <div class="modal-header">
                        <h6 class="modal-title">علت عدم تایید</h6>
                        <button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>توضیحات</label>
                                    <textarea rows="4" class="form-control" v-model="description"></textarea>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <button class="btn btn-success" @click="approveOrRejectAll(false)" data-dismiss="modal">ثبت عدم تایید</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal effect-scale" id="refound" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <form class="modal-content modal-content-demo">
                    <div class="modal-header">
                        <h6 class="modal-title">ثبت مرجوعی سفارش</h6>
                        <button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label for="reason">علت</label>
                            <select id="reason" class="form-control" v-model="returnId">
                                <option :value="returnTitle.returnId" v-for="(returnTitle,index) in returns" :key="index">{{ returnTitle.description }}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="description">توضیحات</label>
                            <textarea id="description" class="form-control" rows="3" v-model="returnDescription"></textarea>
                        </div>
                        <button class="btn btn-success" type="button" @click="returnOrder" data-dismiss="modal">ثبت مرجوعی</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Single',
    data(){
        return {
            showLoading: true,
            paymentIdentifier: '',
            rrn: '',
            amount: 0,
            file: '',
            discount: null,
            deposit: 0,
            description: '',
            returns: [],
            flows: [],
            returnId: 0,
            token: '',
            returnDescription: '',
            order: {}
        }
    },
    methods: {
        setToken(){
            this.$api.post('Management/Card/VerifyToken',{otpCode: this.token.toString()}).then(({data}) => {
                if(data.result){
                    this.$store.state.adminToken = this.token;
                    this.$store.state.adminTokenExpireTime = new Date().getTime() + (5 * 60 * 1000);
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'کد اعتبارسنجی با موفقیت ثبت شد'
                    });
                    $('#cards-pans').modal('toggle');
                }else
                    this.$swal({
                        title: 'خطا',
                        icon: 'error',
                        text: 'کد وارد شده اشتباه است'
                    });
            }).finally(() => {
                this.showLoading = false;
            });
        },
        getCardsDetails(key){
            if(new Date().getTime() <= this.$store.state.adminTokenExpireTime){
                const postedData = {
                    orderId: parseInt(this.$route.params.id),
                    key,
                    otpCode: this.$store.state.adminToken
                };
                this.$api.post('Management/Card/Sheet',postedData).then(({data}) => {
                    let a = window.document.createElement('a');
                    a.setAttribute('href','https://cardapi.sabinarya.com/api/v1/Lookup/download/' + data.result.fileString);
                    let fileName = data.result.fileString;
                    a.setAttribute('download',fileName);
                    window.document.body.appendChild(a);
                    a.click();
                    window.document.body.removeChild(a);
                });
            }else
                this.$api.post('Management/Card/GenerateToken').then(({data}) => {
                    if(data.status)
                        this.$store.state.adminTokenExpireTime = new Date().getTime() + (5 * 60 * 1000);
                });
        },
        async getData(){
            this.$api.get('Management/Returns').then(({data}) => {
                this.returns = data.result;
            });
            if(this.$store.state.userData.isOrganization){
                this.$api.get('Organizations/Wallet/Balance').then(({data}) => {
                    if(data.status)
                        this.deposit = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(data.result);
                });
            }
            this.$api.get('Orders/' + this.$route.params.id).then(({data}) => {
                let orderItems = [];
                data.result.orderItems.map(item => {
                    if(!item.themeId){
                        let orderItemImage = item.cardMetadata.filter(meta => meta.metadataKeyId == 2)[0];
                        orderItems.push({
                            ...item,
                            imageUrl: 'data:image/png;base64,' + orderItemImage.value,
                        });
                    }else
                        orderItems.push({
                            ...item
                        });
                });
                this.order = data.result;
                this.order.orderItems = orderItems;
            }).finally(() => {
                this.showLoading = false;
            });
            await this.$api.get('Flows/' + 2).then(({data}) => {
                let flows = data.result;
                let finalFlows = [];
                let subFlows = {};
                flows.map(flow => {
                    subFlows = {};
                    flow.flowStepStatuses.map(flowStep => {
                        subFlows[flowStep.flowStepStatusId] = flowStep.title
                    });
                    finalFlows.push({
                        title: flow.title,
                        sort: flow.sort,
                        subFlows
                    });
                });
                this.flows = finalFlows;
            });
        },
        downloadImage(base64){
            let image = new Image();
            image.src = base64;
            let newWindow = window.open('');
            newWindow.document.write(image.outerHTML);
        },
        downloadImageDirectly(itemId){
            window.open('https://cardapi.sabinarya.com/api/v2/Metadata/Download?orderItemId=' + itemId);
        },
        financialApprove(){
            this.showLoading = true;
            this.$api.post('Management/FinancialApprove',{orderId: parseInt(this.$route.params.id),confirm: true}).then(({data}) => {
                this.showLoading = false;
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'تایید مالی درخواست با موفقیت انجام شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                    this.getData();
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        approveOrRejectAll(approve){
            this.$swal({
                title: 'هشدار',
                text: 'از انجام این کار اطمینان دارید ؟',
                icon: 'warning',
                confirmButtonText: 'تایید',
                showCancelButton: true,
                cancelButtonText: 'لغو'
            }).then(res => {
                if(res.isConfirmed){
                    this.showLoading = true;
                    const postedData = {
                        orderId: this.$route.params.id,
                        approve
                    };
                    if(this.discount)
                        postedData.discount = this.discount;
                    if(!approve)
                        postedData.description = this.description;
                    this.$api.post('Organizations/Bonus/Order/Approve',postedData).then(({data}) => {
                        if(data.status){
                            this.$swal({
                                title: 'تبریک',
                                icon: 'success',
                                text: 'سفارش با موفقیت ' + (!approve ? 'عدم تایید' : 'تایید') + ' شد',
                                confirmButtonText: 'متوجه شدم'
                            });
                            this.getData();
                        }

                    }).finally(() => {
                        this.showLoading = false;
                    });
                }
            });
        },
        numberFormat(){
            let value = this.amount.toString().replace(/,/g,'');
            value = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(value);
            if(value == 'NaN')
                value = '';
            if(this.amount.toString().replace(/,/g,'') > this.order.totalAmount)
                this.amount = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(this.order.totalAmount);
            else
                this.amount = value;
        },
        returnOrder(){
            this.showLoading = true;
            const postedData = {
                orderId: parseInt(this.$route.params.id),
                description: this.returnDescription,
                returnId: this.returnId
            };
            this.$api.post('Management/ReturnItems',postedData).then(({data}) => {
                if(data.status){
                    this.showLoading = false;
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'ثبت مرجوعی با موفقیت انجام شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                    this.getData();
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        async toBase64(file){
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        async setFile(e){
            const file = e.target.files[0];
            const finalFile = await this.toBase64(file);
            this.file = finalFile;
            document.getElementById('file-input').setAttribute('placeholder',file.name);
        },
        submitPayment(){
            this.showLoading = true;
            const postedData = {
                paymentIdentifier: this.paymentIdentifier,
                rrn: this.rrn,
                amount: parseInt(this.amount.toString().replace(/,/g,'')),
                orderId: parseInt(this.$route.params.id),
                base64Receipt: this.file
            };
            this.$api.post('Organizations/SubmitPayment',postedData).then(({data}) => {
                if(data.status){
                    this.paymentIdentifier = this.amount = this.rrn = this.pansFile = '';
                    document.getElementById('file-input').setAttribute('placeholder','');
                    this.getData();
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'ثبت اطلاعات پرداخت با موفقیت انجام شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                }
            }).catch(({response}) => {
                this.showLoading = false;
            });
        },
        payWithWallet(){
            this.showLoading = true;
            this.$api.post('Organizations/Bonus/Order/WalletPayment',{orderId: this.$route.params.id}).then(({data}) => {
                if(data.status){
                    this.getData();
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'پرداخت با موفقیت انجام شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        sent(){
            this.showLoading = true;
            const postedData = {
                orderId: parseInt(this.$route.params.id),
                flowStepStatusId: 8
            };
            this.$api.post('Management/UpdateOrderStatus',postedData).then(({data}) => {
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'وضعیت سفارش با موفقیت به روزرسانی شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                    this.getData();
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        chargeDeposit(){
            let amount = this.order.totalAmount - parseInt(this.deposit.toString().replace(/,/g,''));
            localStorage.setItem('amount',amount);
            this.$router.push({name: 'organization.wallet'});
        },
        delivered(){
            this.showLoading = true;
            const postedData = {
                orderId: parseInt(this.$route.params.id),
                flowStepStatusId: 7
            };
            this.$api.post('Management/UpdateOrderStatus',postedData).then(({data}) => {
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'وضعیت سفارش با موفقیت به روزرسانی شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                    this.getData();
                }
            }).finally(() => {
                this.showLoading = false;
            });
        }
    },
    created(){
        this.getData();
    }
}
</script>